import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetPageQuery } from '../../../store/api/adminApi';
import PageLoader from '../../../components/PageLoader';
import { useLanguage } from '../../../context/LanguageContext';

const AdminPageView: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, error } = useGetPageQuery(id!);

  if (isLoading) {
    return <PageLoader />;
  }

  if (error || !data?.data) {
    return <div className="alert alert-danger m-5">{t('Page not found')}</div>;
  }

  const page = data.data;

  return (
    <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
      <div className="d-flex flex-column flex-column-fluid">
        <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
          <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
            <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
              <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">{t('Page Details')}</h1>
              <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <li className="breadcrumb-item text-muted">
                  <a href="#" onClick={(e) => { e.preventDefault(); navigate('/admin/dashboard'); }} className="text-muted text-hover-primary">{t('Home')}</a>
                </li>
                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li className="breadcrumb-item text-muted">
                  <a href="#" onClick={(e) => { e.preventDefault(); navigate('/admin/pages'); }} className="text-muted text-hover-primary">{t('Pages')}</a>
                </li>
              </ul>
            </div>
            <div className="d-flex align-items-center gap-2 gap-lg-3">
              <button className="btn btn-primary" onClick={() => navigate(`/admin/pages/${id}/edit`)}>
                {t('Edit Page')}
              </button>
            </div>
          </div>
        </div>
        
        <div id="kt_app_content" className="app-content flex-column-fluid">
          <div id="kt_app_content_container" className="app-container container-xxl">
            <div className="card">
              <div className="card-body pt-0">
                <div className="row g-9 my-3">
                  <div className="col-md-6">
                    <label className="fs-6 fw-semibold mb-2">{t('Title')}</label>
                    <div className="form-control form-control-solid">{page.title}</div>
                  </div>
                  <div className="col-md-6">
                    <label className="fs-6 fw-semibold mb-2">{t('Title (Arabic)')}</label>
                    <div className="form-control form-control-solid">{page.title_ar || t('N/A')}</div>
                  </div>
                  <div className="col-md-6">
                    <label className="fs-6 fw-semibold mb-2">{t('Slug')}</label>
                    <div className="form-control form-control-solid">{page.slug || t('N/A')}</div>
                  </div>
                  <div className="col-md-12">
                    <label className="fs-6 fw-semibold mb-2">{t('Content')}</label>
                    <div className="form-control form-control-solid" style={{ minHeight: '200px' }} dangerouslySetInnerHTML={{ __html: page.content || 'N/A' }}></div>
                  </div>
                  <div className="col-md-12">
                    <label className="fs-6 fw-semibold mb-2">{t('Content (Arabic)')}</label>
                    <div className="form-control form-control-solid" style={{ minHeight: '200px' }} dangerouslySetInnerHTML={{ __html: page.content_ar || 'N/A' }}></div>
                  </div>
                </div>
                
                <div className="card-footer d-flex justify-content-end py-6 px-9">
                  <button type="button" className="btn btn-light btn-active-light-primary me-2" onClick={() => navigate('/admin/pages')}>
                    {t('Back')}
                  </button>
                  <button type="button" className="btn btn-primary" onClick={() => navigate(`/admin/pages/${id}/edit`)}>
                    {t('Edit Page')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPageView;















